import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, watch } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { UserUpdateDocument, UserType } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue-next';

// --- Props for user details ---

export default /*@__PURE__*/_defineComponent({
  __name: 'UserPersonalDetails',
  props: {
    user: {},
    loading: { type: Boolean }
  },
  emits: ['userUpdated'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Local state for user details ---
const userFormValues = ref<Partial<UserType>>({});

// Watch the incoming user details for updates => update local form
watch(
  () => props.user,
  (newVal) => {
    console.debug('User details updated:', newVal);
    userFormValues.value = {
      email: newVal?.email || '',
      givenName: newVal?.givenName || '',
      familyName: newVal?.familyName || '',
    };
  },
  { immediate: true }
);

// --- Emit "userUpdated" when personal details are updated ---
const emits = __emit;

// Loading and Error States
const loadingUpdatePersonal = ref(false);
const showUpdateSuccess = ref(false);
const errorUpdatePersonal = ref<string | null>(null);

// --- Mutation to updated user`s personal details ---
const {
  mutate: updateDetails,
  onDone: onUpdateDone,
  onError: onUpdateError,
} = useMutation(UserUpdateDocument);

// Handle the result of the mutation
onUpdateDone((res) => {
  if (res.data && res.data.userUpdate) {
    console.debug('User details updated:', res.data.userUpdate);
    emits('userUpdated');
    // Show success indicator and hider after 2 seconds
    loadingUpdatePersonal.value = false;
    showUpdateSuccess.value = true;
    setTimeout(() => {
      showUpdateSuccess.value = false;
    }, 1000);
  } else {
    console.error('User update failed:', res.data);
  }
});

// Handle errors in the mutation
onUpdateError((err) => {
  console.error('Error updating user details:', err);
  loadingUpdatePersonal.value = false;
  errorUpdatePersonal.value = err.message;
});

// Submit form with personal details
async function onSubmit() {
  // Reset error and submit the update request
  errorUpdatePersonal.value = null;
  loadingUpdatePersonal.value = true;

  updateDetails({
    givenName: userFormValues.value.givenName,
    familyName: userFormValues.value.familyName,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BForm), {
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BFormGroup), {
          id: "input-group-email",
          label: "Email address",
          "label-for": "input-email",
          description: "E-mail address cannot be changed.",
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormInput), {
              disabled: "",
              id: "input-email",
              modelValue: userFormValues.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userFormValues.value.email) = $event)),
              type: "email",
              name: "email",
              placeholder: "Enter email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BFormGroup), {
          id: "input-group-given-name",
          label: "Given Name",
          "label-for": "input-given-name",
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormInput), {
              id: "input-given-name",
              name: "givenName",
              required: "",
              modelValue: userFormValues.value.givenName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userFormValues.value.givenName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BFormGroup), {
          id: "input-group-family-name",
          label: "Family Name",
          "label-for": "input-family-name",
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormInput), {
              id: "input-family-name",
              name: "familyName",
              required: "",
              modelValue: userFormValues.value.familyName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userFormValues.value.familyName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BFormGroup), { class: "mt-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(BButton), {
              type: "submit",
              variant: "outline-dark",
              disabled: loadingUpdatePersonal.value
            }, {
              default: _withCtx(() => [
                (loadingUpdatePersonal.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _cache[5] || (_cache[5] = _createTextVNode(" Saving Changes ", -1)),
                      _createVNode(_unref(BSpinner), {
                        small: "",
                        label: ""
                      })
                    ]))
                  : (showUpdateSuccess.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _cache[6] || (_cache[6] = _createTextVNode(" Changes Saved ", -1)),
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fa', 'check-double'],
                          class: "me-2"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, " Save Changes "))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BAlert), {
          modelValue: errorUpdatePersonal.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((errorUpdatePersonal).value = $event)),
          variant: "danger",
          dismissible: "",
          class: "mt-3",
          onDismissed: _cache[4] || (_cache[4] = ($event: any) => (errorUpdatePersonal.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(errorUpdatePersonal.value), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})